/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/promotion.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopPay from '../student/_PopPay';

const PRClass = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '요청중', cnt: '46', value: 0},
    {title: '요청승인', cnt: '653', value: 1},
    {title: '내 요청', cnt: '652', value: 2}
  ];
  return (
    <main className="com_container p_pr_class">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_1">시범강의 신청</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">시범강의 신청</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="10%" />
                <col width="10%" />
                <col width="7%" />
                <col width="10%" />
                <col width="10%" />
                <col width="15%" />
                <col width="7%" />
                <col width="7%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>
                    신청일
                    <button className="arrow" />
                  </th>
                  <th>홍보자</th>
                  <th>학생명</th>
                  <th>전화번호</th>
                  <th>
                    시강요청 일시
                    <button className="arrow" />
                  </th>
                  <th>시강위치</th>
                  <th>시강담임</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>김홍보305</td>
                  <td>김학생</td>
                  <td>010-1234-1324</td>
                  <td>
                    20223, 01, 23
                    <br />
                    18:30
                  </td>
                  <td>서울시 강남구 언주역 4번출구</td>
                  <td>김담임103</td>
                  <td className="td_red">탈락</td>
                </tr>
                <tr>
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>김홍보305</td>
                  <td>김학생</td>
                  <td>010-1234-1324</td>
                  <td>
                    20223, 01, 23
                    <br />
                    18:30
                  </td>
                  <td>서울시 강남구 언주역 4번출구</td>
                  <td>김담임103</td>
                  <td className="td_point">
                    승인
                    <br />
                    2023, 05, 12
                  </td>
                </tr>
                <tr>
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>김홍보305</td>
                  <td>김학생</td>
                  <td>010-1234-1324</td>
                  <td>
                    20223, 01, 23
                    <br />
                    18:30
                  </td>
                  <td>서울시 강남구 언주역 4번출구</td>
                  <td>김담임103</td>
                  <td></td>
                </tr>
                <tr>
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>김홍보305</td>
                  <td>김학생</td>
                  <td>010-1234-1324</td>
                  <td>
                    20223, 01, 23
                    <br />
                    18:30
                  </td>
                  <td>서울시 강남구 언주역 4번출구</td>
                  <td>김담임103</td>
                  <td></td>
                </tr>
                <tr className="selected">
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>김홍보305</td>
                  <td>김학생</td>
                  <td>010-1234-1324</td>
                  <td>
                    20223, 01, 23
                    <br />
                    18:30
                  </td>
                  <td>서울시 강남구 언주역 4번출구</td>
                  <td>김담임103</td>
                  <td></td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>17</td>
                      <td className="td_date">2022,08,25</td>
                      <td>김홍보305</td>
                      <td>김학생</td>
                      <td>010-1234-1324</td>
                      <td>
                        20223, 01, 23
                        <br />
                        18:30
                      </td>
                      <td>서울시 강남구 언주역 4번출구</td>
                      <td>김담임103</td>
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <Paging />
              <div className="com_btn_wrap ">
                <button className="com_btn black xs btn_print">인쇄하기</button>
              </div>
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20</p>
              <div className="count">
                <button className="btn_edit"></button>
                <button className="btn_delete"></button>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont bold">김학생</span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont bold">010-1234-0134</span>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <span className="cont">부)010-1234-0134ㆍ모)010-1345-3214</span>
                </div>
                <div className="info">
                  <span className="tit">홍보일시</span>
                  <span className="cont">2023, 05, 08 10:30</span>
                </div>
                <div className="info">
                  <span className="tit">시범강의 예정일시</span>
                  <span className="cont">2023, 05, 12</span>
                </div>
                <div className="info">
                  <span className="tit">시범강의 장소</span>
                  <span className="cont">서울특별시 강남대로 강남빌딩 105호</span>
                </div>
                <div className="info">
                  <span className="tit">메모</span>
                  <span className="cont">부모님이 적극적이십니다. 잘 부탁드립니다.</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon blue">승인</span>
                    <button className="name">김승인205 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <div className="cont">
                    <span className="bold"> 시범 강의자 명 :</span>
                    <span className="com_blue_txt">김담임103 </span>
                    <div>잘 부탁 드립니다.</div>
                  </div>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon blue">승인</span>
                    <button className="name">김승인205 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  시범강의자 내용 입력
                  <br />
                  홍보가 잘 되어서 바로 학생등록 진행 하겠습니다.
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_row">
                <select className="select">
                  <option value="승인 불가">승인 불가</option>
                </select>
                <section className="com_board_search">
                  <article className="search">
                    <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input xs type_search" />
                    <button className="com_btn gray ws xs icon_search"></button>
                  </article>
                </section>
              </div>
            </div>

            <div className="com_comment_wrap">
              <textarea className="textarea" placeholder="내용 입력"></textarea>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default PRClass;
